import { updateField } from 'vuex-map-fields'
export const SET_SNACKBAR = 'SET_SNACKBAR'

export default {
  updateField,
  SET_BAR_IMAGE (state, payload) {
    state.barImage = payload
  },
  SET_DRAWER (state, payload) {
    state.drawer = payload
  },
  SET_USER (state, payload) {
    state.user = payload
  },
  SET_SELECTED (state, payload) {
    state.drawer_selected = payload
  },
  SET_SNACKBAR (state, payload) {
    state.snackbar = payload
  },
  SET_PERMISSIONS (state, payload) {
    state.permissions = payload
  },
  SET_CRUD_FILTER (state, payload) {
    state.crud_filter = payload
  },
}
